(function () {
  const CUSTOM_CURRENCY_PREFIX = 'AUD';

  function patchProgressBarCurrency() {
    if (!window.tlCartGoalEmbed || window.tlCartGoalEmbed._currencyPatched) return;

    const originalFormatMoney = window.tlCartGoalEmbed.formatMoney;

    window.tlCartGoalEmbed.formatMoney = function (amount, currencyFormat, currencyDisplay) {
      let formatted = originalFormatMoney.call(this, amount, currencyFormat, currencyDisplay);

      const activeCurrency = this.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "";

      if (activeCurrency && formatted.endsWith(activeCurrency)) {
        let amountOnly = formatted.slice(0, -activeCurrency.length).trim();
        const prefix = CUSTOM_CURRENCY_PREFIX !== null ? CUSTOM_CURRENCY_PREFIX : activeCurrency;
        return `${prefix} ${amountOnly}`;
      }

      return formatted;
    };

    window.tlCartGoalEmbed._currencyPatched = true;

    if (typeof window.tlCartGoalEmbed.render === "function") {
      window.tlCartGoalEmbed.render();
    }
  }

  if (window.tlCartGoalEmbed) {
    patchProgressBarCurrency();
  } else {
    const timer = setInterval(function () {
      if (window.tlCartGoalEmbed) {
        clearInterval(timer);
        patchProgressBarCurrency();
      }
    }, 50);
    setTimeout(function () { clearInterval(timer); }, 5000);
  }
})();

//  Salepify Cart Goal: chống progress bar lỗi khi add to cart 
(function () {
  var MAX_WAIT_MS = 15000;
  var startedAt = Date.now();

  function patch(embed) {
    if (!embed || embed.__tlFlickerPatched) return;
    embed.__tlFlickerPatched = true;

    var originalUpdateCartTotal = embed.updateCartTotal;
    var originalRenderAll = embed.renderAllCartGoals;
    var skipRender = false;
    var debounceTimer = null;
    var observer = null;
    var observerTimer = null;
    var observerDebounce = null;

    // 1. Không render với cartTotal cũ ngay khi updateCartTotal vừa được gọi
    embed.renderAllCartGoals = function () {
      if (skipRender) return;
      return originalRenderAll.apply(this, arguments);
    };

    // 2. Gộp nhiều cart event liên tiếp (add -> change -> update) thành 1 lần
    embed.updateCartTotal = function () {
      var self = this,
        args = arguments;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        skipRender = true;
        try {
          originalUpdateCartTotal.apply(self, args);
        } finally {
          skipRender = false;
        }
      }, 150);
    };

    // 3. Thay observer bị lỗi bằng 1 observer duy nhất, debounce đúng,
    //    bỏ qua thay đổi DOM do chính widget gây ra
    function isOwnNode(node) {
      if (!node || node.nodeType !== 1) node = node && node.parentElement;
      return !!(
        node &&
        node.closest &&
        node.closest('.tl-custom-cart-goal-container, .tl__cart-goal__gift-modal, .tl__cart-goal__check-box')
      );
    }

    function stopObserver() {
      if (observer) observer.disconnect();
      observer = null;
      clearTimeout(observerTimer);
      clearTimeout(observerDebounce);
    }

    embed.trackingCartDrawerWhenAddtoCart = function () {
      var self = this;
      self.updateAllCartGoals();
      stopObserver();

      observer = new MutationObserver(function (mutations) {
        var external = mutations.some(function (m) {
          if (isOwnNode(m.target)) return false;
          var nodes = Array.prototype.slice.call(m.addedNodes).concat(Array.prototype.slice.call(m.removedNodes));
          return nodes.some(function (n) {
            return !(n.nodeType === 1 && n.classList && n.classList.contains('tl-custom-cart-goal-container'));
          });
        });
        if (!external) return;

        clearTimeout(observerDebounce);
        observerDebounce = setTimeout(function () {
          stopObserver();
          self.updateAllCartGoals();
        }, 400);
      });

      observer.observe(document.body, { childList: true, subtree: true });
      // Theme không re-render drawer thì tự tắt observer
      observerTimer = setTimeout(stopObserver, 4000);
    };
  }

  (function waitForEmbed() {
    if (window.tlCartGoalEmbed) return patch(window.tlCartGoalEmbed);
    if (Date.now() - startedAt < MAX_WAIT_MS) setTimeout(waitForEmbed, 100);
  })();
})();
